import lab from './pages/lab-homepage/lab-homepage.js';

export default () => {
  lab();
};
